import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TealiumAnalyticsAdapter } from './adapters/tealium-adapter';
import { TealiumAnalyticsDirective } from './directives/tealium-analytics.directive';
import { AnalyticsManager } from './managers/analytics.manager';
import { AnalyticEventEvaluatorPipe } from './pipes/analytic-event-evaluator.pipe';
import { TealiumAnalyticsService } from './services/tealium-analytics.service';

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		TealiumAnalyticsService,
		TealiumAnalyticsAdapter,
		AnalyticsManager
	],
	declarations: [
		AnalyticEventEvaluatorPipe,
		TealiumAnalyticsDirective
	],
	exports: [
		AnalyticEventEvaluatorPipe,
		TealiumAnalyticsDirective
	]
})
export class AnalyticsModule { }
